import { __extends } from "tslib";
import { PutAccountLinkStatusWithTokenJustificationInputFilterSensitiveLog, PutAccountLinkStatusWithTokenJustificationOutputFilterSensitiveLog, } from "../models/models_0";
import { deserializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCommand, serializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutAccountLinkStatusWithTokenJustificationCommand = (function (_super) {
    __extends(PutAccountLinkStatusWithTokenJustificationCommand, _super);
    function PutAccountLinkStatusWithTokenJustificationCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PutAccountLinkStatusWithTokenJustificationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "GandalfLoginAssociationClient";
        var commandName = "PutAccountLinkStatusWithTokenJustificationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: PutAccountLinkStatusWithTokenJustificationInputFilterSensitiveLog,
            outputFilterSensitiveLog: PutAccountLinkStatusWithTokenJustificationOutputFilterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutAccountLinkStatusWithTokenJustificationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCommand(input, context);
    };
    PutAccountLinkStatusWithTokenJustificationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCommand(output, context);
    };
    return PutAccountLinkStatusWithTokenJustificationCommand;
}($Command));
export { PutAccountLinkStatusWithTokenJustificationCommand };
